<ion-header class="admin-header">
  <ion-toolbar>
    <div class="header-content">
      <div class="brand">
        <ion-icon name="shield-checkmark" class="brand-icon"></ion-icon>
        <span class="brand-text">Admin Dashboard</span>
      </div>
      <div class="header-actions">
        <div class="user-info">
          <ion-icon name="person-circle-outline"></ion-icon>
          <span>{{ adminEmail }}</span>
        </div>
        <button class="logout-btn" (click)="logout()">
          <ion-icon name="log-out-outline"></ion-icon>
          <span>Logout</span>
        </button>
      </div>
    </div>
  </ion-toolbar>
</ion-header>

<ion-content class="admin-content">
  <div class="dashboard-container">
    <!-- Stats Cards -->
    <div class="stats-section">
      <div class="stat-card">
        <div class="stat-icon applications">
          <ion-icon name="document-text-outline"></ion-icon>
        </div>
        <div class="stat-info">
          <span class="stat-value">{{ totalItems }}</span>
          <span class="stat-label">Total Applications</span>
        </div>
      </div>
      <div class="stat-card">
        <div class="stat-icon pages">
          <ion-icon name="layers-outline"></ion-icon>
        </div>
        <div class="stat-info">
          <span class="stat-value">{{ totalPages }}</span>
          <span class="stat-label">Total Pages</span>
        </div>
      </div>
      <div class="stat-card">
        <div class="stat-icon current">
          <ion-icon name="bookmark-outline"></ion-icon>
        </div>
        <div class="stat-info">
          <span class="stat-value">{{ currentPage }}</span>
          <span class="stat-label">Current Page</span>
        </div>
      </div>
    </div>

    <!-- Filters Section -->
    <div class="filters-section">
      <!-- <div class="section-header">
        <h2 class="section-title">Job Applications</h2>
        <button class="export-btn" (click)="exportCSV()">
          <ion-icon name="download-outline"></ion-icon>
          <span>Export CSV</span>
        </button>
      </div> -->

      <div class="filters-grid">
        <div class="filter-item search">
          <ion-icon name="search-outline" class="filter-icon"></ion-icon>
          <input
            type="text"
            [(ngModel)]="searchText"
            (keyup.enter)="onSearch()"
            placeholder="Search by title or description..."
            class="filter-input"
          />
        </div>
        
        <!-- <div class="filter-item">
          <ion-icon name="briefcase-outline" class="filter-icon"></ion-icon>
          <input
            type="text"
            [(ngModel)]="selectedCategory"
            (change)="onFilterChange()"
            placeholder="Category"
            class="filter-input"
          />
        </div>
        
        <div class="filter-item">
          <ion-icon name="time-outline" class="filter-icon"></ion-icon>
          <select [(ngModel)]="selectedJobType" (change)="onFilterChange()" class="filter-select">
            <option value="">All Job Types</option>
            <option *ngFor="let type of jobTypes" [value]="type">{{ type }}</option>
          </select>
        </div>
        
        <div class="filter-item">
          <ion-icon name="location-outline" class="filter-icon"></ion-icon>
          <input
            type="text"
            [(ngModel)]="selectedCityCode"
            (change)="onFilterChange()"
            placeholder="City Code"
            class="filter-input"
          />
        </div> -->

        <div class="filter-item">
          <ion-icon name="globe-outline" class="filter-icon"></ion-icon>
          <select [(ngModel)]="selectedOnlineApplication" (change)="onFilterChange()" class="filter-select">
            <option value="">All Applications</option>
            <option value="true">Online Only</option>
            <option value="false">Offline Only</option>
          </select>
        </div>

        <button class="filter-btn export-btn" (click)="exportCSV()">
          <ion-icon name="download-outline"></ion-icon>
          Export CSV
        </button>

        <button class="filter-btn search-btn" (click)="onSearch()">
          <ion-icon name="search"></ion-icon>
          Search
        </button>

        <button class="filter-btn clear-btn" (click)="clearFilters()">
          <ion-icon name="close-circle-outline"></ion-icon>
          Clear
        </button>
      </div>
    </div>

    <!-- Loading State -->
    <div class="loading-state" *ngIf="isLoading">
      <ion-spinner name="crescent"></ion-spinner>
      <span>Loading applications...</span>
    </div>

    <!-- Error State -->
    <div class="error-state" *ngIf="errorMessage && !isLoading">
      <ion-icon name="alert-circle-outline"></ion-icon>
      <span>{{ errorMessage }}</span>
      <button class="retry-btn" (click)="loadApplications()">Retry</button>
    </div>

    <!-- Empty State -->
    <div class="empty-state" *ngIf="!isLoading && !errorMessage && applications.length === 0">
      <ion-icon name="folder-open-outline"></ion-icon>
      <span>No applications found</span>
      <p>Try adjusting your filters or search criteria</p>
    </div>

    <!-- Applications Table -->
    <div class="table-container" *ngIf="!isLoading && !errorMessage && applications.length > 0">
      <table class="applications-table">
        <thead>
          <tr>
            <th>Applicant</th>
            <th>Job Title</th>
            <th>Location</th>
            <th>Type</th>
            <th>Applied At</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let app of applications">
            <td class="applicant-cell">
              <div class="applicant-info">
                <div class="avatar">{{ getUserName(app.user)?.charAt(0)?.toUpperCase() || '?' }}</div>
                <span class="applicant-name">{{ getUserName(app.user) }}</span>
              </div>
            </td>
            <td>
              <span class="job-title">{{ app.job?.title || 'N/A' }}</span>
            </td>
            <td>
              <span class="location">{{ app.job?.location?.city_name || 'N/A' }}</span>
            </td>
            <td>
              <span class="application-type-badge" [class.online]="app.job?.is_online_application" [class.offline]="!app.job?.is_online_application">
                <ion-icon [name]="app.job?.is_online_application ? 'globe-outline' : 'location-outline'"></ion-icon>
                {{ app.job?.is_online_application ? 'Online' : 'Offline' }}
              </span>
            </td>
            <td>
              <span class="date">{{ formatDate(app.applied_at) }}</span>
            </td>
            <td>
              <button class="view-btn" (click)="viewApplication(app)">
                <ion-icon name="eye-outline"></ion-icon>
                View
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <div class="pagination" *ngIf="!isLoading && totalPages > 1">
      <button class="page-btn" [disabled]="currentPage === 1" (click)="previousPage()">
        <ion-icon name="chevron-back-outline"></ion-icon>
        Previous
      </button>
      
      <div class="page-numbers">
        <button
          *ngFor="let page of [].constructor(totalPages); let i = index"
          class="page-number"
          [class.active]="currentPage === i + 1"
          (click)="goToPage(i + 1)"
        >
          {{ i + 1 }}
        </button>
      </div>

      <button class="page-btn" [disabled]="currentPage === totalPages" (click)="nextPage()">
        Next
        <ion-icon name="chevron-forward-outline"></ion-icon>
      </button>
    </div>
  </div>
</ion-content>

<!-- Application Details Modal -->
<div class="modal-overlay" *ngIf="showModal" (click)="closeModal()">
  <div class="modal-container" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2>Application Details</h2>
      <button class="modal-close" (click)="closeModal()">
        <ion-icon name="close-outline"></ion-icon>
      </button>
    </div>
    
    <div class="modal-body" *ngIf="selectedApplication">
      <!-- Applicant Section -->
      <div class="detail-section">
        <h3 class="section-label">
          <ion-icon name="person-outline"></ion-icon>
          Applicant Information
        </h3>
        <div class="detail-grid">
          <div class="detail-item">
            <span class="detail-label">Name</span>
            <span class="detail-value">{{ getUserName(selectedApplication.user) }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">Email</span>
            <span class="detail-value">{{ selectedApplication.user?.email || 'N/A' }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">Phone</span>
            <span class="detail-value">{{ selectedApplication.user?.phone || 'N/A' }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">Gender</span>
            <span class="detail-value">{{ selectedApplication.user?.gender || 'N/A' }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">Age</span>
            <span class="detail-value">{{ selectedApplication.user?.age || 'N/A' }}</span>
          </div>
          <div class="detail-item full-width">
            <span class="detail-label">Skills</span>
            <span class="detail-value">{{ getSkills(selectedApplication.user) }}</span>
          </div>
          <div class="detail-item full-width">
            <span class="detail-label">Languages</span>
            <span class="detail-value">{{ getLanguages(selectedApplication.user) }}</span>
          </div>
        </div>
      </div>

      <!-- Job Section -->
      <div class="detail-section">
        <h3 class="section-label">
          <ion-icon name="briefcase-outline"></ion-icon>
          Job Information
        </h3>
        <div class="detail-grid">
          <div class="detail-item">
            <span class="detail-label">Job Title</span>
            <span class="detail-value">{{ selectedApplication.job?.title || 'N/A' }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">Category</span>
            <span class="detail-value">{{ selectedApplication.job?.category || 'N/A' }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">Job Type</span>
            <span class="detail-value">{{ selectedApplication.job?.job_type || 'N/A' }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">Application Type</span>
            <span class="detail-value">{{ selectedApplication.job?.is_online_application ? 'Online' : 'Offline' }}</span>
          </div>
          <div class="detail-item full-width">
            <span class="detail-label">Description</span>
            <span class="detail-value">{{ selectedApplication.job?.short_desc || 'N/A' }}</span>
          </div>
        </div>
      </div>

      <!-- Location Section -->
      <div class="detail-section">
        <h3 class="section-label">
          <ion-icon name="location-outline"></ion-icon>
          Location
        </h3>
        <div class="detail-grid">
          <div class="detail-item">
            <span class="detail-label">City</span>
            <span class="detail-value">{{ selectedApplication.job?.location?.city_name || 'N/A' }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">State</span>
            <span class="detail-value">{{ selectedApplication.job?.location?.state_code || 'N/A' }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">Area Code</span>
            <span class="detail-value">{{ selectedApplication.job?.location?.area_code || 'N/A' }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">City Code</span>
            <span class="detail-value">{{ selectedApplication.job?.location?.city_code || 'N/A' }}</span>
          </div>
        </div>
      </div>

      <!-- Provider Section -->
      <div class="detail-section">
        <h3 class="section-label">
          <ion-icon name="business-outline"></ion-icon>
          Provider Information
        </h3>
        <div class="detail-grid">
          <div class="detail-item">
            <span class="detail-label">Provider Name</span>
            <span class="detail-value">{{ selectedApplication.job?.provider?.name || 'N/A' }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">Salary Range</span>
            <span class="detail-value">{{ formatSalary(selectedApplication.job?.compensation) }}</span>
          </div>
        </div>
      </div>

      <!-- Application Section -->
      <div class="detail-section">
        <h3 class="section-label">
          <ion-icon name="calendar-outline"></ion-icon>
          Application Details
        </h3>
        <div class="detail-grid">
          <div class="detail-item">
            <span class="detail-label">Application ID</span>
            <span class="detail-value id-value">{{ selectedApplication.application_id }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">Applied At</span>
            <span class="detail-value">{{ formatDate(selectedApplication.applied_at) }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

